const placeholderImageUrl = window.placeholderImageUrl || './assets/placeholder.jpg';

function validateInput() {
  const inputField = document.getElementById('partNoInput');
  const searchButton = document.getElementById('searchButton');

  if (inputField.value.trim() !== '') {
    searchButton.removeAttribute('disabled');
  } else {
    searchButton.setAttribute('disabled', 'disabled');
  }
}

document.addEventListener('DOMContentLoaded', function () {
   const apiEndPoint = "aagasketapi.azurewebsites.net";
   const partNoInput = document.getElementById('partNoInput');
  //  var apiEndPoint = "localhost:7146";
  // Attach an event listener to the search button
  const searchButton = document.getElementById('partSearchButton');
  searchButton.addEventListener('click', handleSearch);

  partNoInput.addEventListener('keypress', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission (if inside a form)
      handleSearch(); // Call search function
    }
  })
  // Function to handle the search button click
  async function handleSearch() {
    // Get the input value from the text box
    const partNoInput = document.getElementById('partNoInput');
    const partNo = partNoInput.value.trim();

    // Check if the input is not empty
    if (partNo !== '') {
      const resultsContainer = document.getElementById('resultsContainer3');
      resultsContainer.innerHTML = '';
      // Show loading spinner
      const loadingSpinner = document.getElementById('loadingSpinner3');
      loadingSpinner.style.display = 'inline-block';

      try {
        // Fetch data from the API
        const apiUrl = `https://${apiEndPoint}/AutoInfoSearchNZ/GetPartByPartNo?partNumber=${encodeURIComponent(partNo)}`;
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data && data?.parts?.length < 1) {
          renderResults(data);
          // Redirect to another page
          // const productURL =`/products/${data.products[0].shopifyProductUrl}` ;
          //window.location.href = productURL;
          // window.open(productURL, '_blank');
        } else {
          // Render the results in the "resultsContainer3" div
          renderResults(data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        // Hide loading spinner after fetching data
        loadingSpinner.style.display = 'none';

      }
    } else {
      // Handle case where input is empty
      alert('Please enter a part number before searching.');
    }
  }

  // Function to render the API results
  function renderResults(data) {
    const resultsContainer = document.getElementById('resultsContainer3');
    const partNoInput = document.getElementById('partNoInput');
    const partNo = partNoInput.value.trim();

    resultsContainer.innerHTML = '';
    // Clear previous results
    resultsContainer.innerHTML = `<div class="row d-flex mb-4 pb-4">
        <div class="col-md-8">
          <span class="fs-2 fw-bold lh-1">Results for:</span>
          <span class="fs-1 fw-black lh-1">${partNo} </span><br>
        </div>
      </div>`;

    if (data && data?.parts?.length > 0) {
      data.parts.forEach(function (part) {
        var productCatalogDiv = document.createElement('div');
        productCatalogDiv.classList.add('product-catalog', 'col-12', 'col-md-12', 'card', 'mb-2');
        const imageUrl = part.baseimageurl ?  `https://api.autoinfo.com.au${part.baseimageurl}`: placeholderImageUrl;
        // Inner HTML for product catalog
        productCatalogDiv.innerHTML = `
            <div class="d-flex g-0">
                <div class="col-2 col-md-2 border-end">
                    <a href="#"><img src="${imageUrl}" class="img-fluid rounded-start-2 view-image" alt="" data-product-url="${imageUrl || ''}"></a>
                  </div>
                <div class="card-body col-9 col-md-9 card-h">
                    <div class="d-md-flex">
                        <div class="col-12 col-md-4 pe-2">
                            <div class="text-body">
                                <h4 class="card-title"><a href="#" class="pt-0">${part.partDescription}</a></h4>
                                <h6 class="card-sub-title">${part.sku}</h6>
                                <p class="text-danger">Quantity Required: 1</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="text-body">
                                  ${part.footnote === part.longFootnote ?
          (part.footnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${part.footnote}</p>` :
            '') :
          (part.footnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${part.footnote}</p>` :
            '') +
          (part.longFootnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${part.longFootnote}</p>` :
            '')}
                            </div>
                        </div>
                        <div class="col-12 col-md-2 pt-2 pt-md-0">
                            <button type="button" class="btn btn-primary me-2 my-1 view-details mx-auto d-block" aria-controls="modal-quick-view" data-product-url="${part.baseimageurl}" data-product-id="${part.paprId}" data-product='${JSON.stringify(part)}'>
                                View Details
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        resultsContainer.appendChild(productCatalogDiv);
        // Add event listener for the "View Details" button click
        var viewDetailsButton = productCatalogDiv.querySelector('.view-image');
        viewDetailsButton.addEventListener('click', async function (e) {
          e.preventDefault();
          const imageUrl = part.baseimageurl ?  `https://api.autoinfo.com.au${part.baseimageurl}` : placeholderImageUrl;


          // Open the image modal
          openImageModal(imageUrl);
        });

        var viewDetailsButton = productCatalogDiv.querySelector('.view-details');
        viewDetailsButton.addEventListener('click', async function (e) {
          let target=e.target;
      let productDataString = this.getAttribute('data-product');
      let product = JSON.parse(productDataString);
      console.log("product", product);
    
          e.preventDefault();
          const imageUrl = part.baseimageurl;

          // Open the details modal
          openDetailsModal(product);
        });



      });

      // async function openDetailsModal(part) {
      //   let modal = document.getElementById(target.getAttribute('aria-controls'));
      //   modal.classList.add('is-loading');
      //   let content = await fetchProductDetailsAndOpenModal(product);
      //   modal.querySelector('.modal__inner').innerHTML = content;
      //   modal.classList.remove('is-loading');
      //   modal.classList.add('modal-dialog-centered');
      //   document.querySelector('body').classList.add('show_overlay');
      //   modal.setAttribute('aria-hidden', 'false');
      // }
      // Function to open the details modal
      async function openDetailsModal(part) {
        let modal = document.getElementById("modal-quick-view");
        modal.classList.add('is-loading');
        let content = await fetchProductDetailsAndOpenModal(part);
        modal.querySelector('.modal__inner').innerHTML = content;
        modal.classList.remove('is-loading');
        modal.classList.add('modal-dialog-centered');
        document.querySelector('body').classList.add('show_overlay');
        modal.setAttribute('aria-hidden', 'false');
      }

      // // Function to fetch product details and update modal content
      // async function fetchProductDetailsAndOpenModal(part) {
      //   return await fetchProductDetails(part.productId)
      //     .then(async productDetails => {
      //       document.cookie = `xuserid=${productDetails?.xuserid}; path=/`;
      //       const proDetails = {
      //         "ID": productDetails?.model?.dimensions?.find(d => d.description === "ID")?.dimensiondisplay,
      //         "OD": productDetails?.model?.dimensions?.find(d => d.description === "OD")?.dimensiondisplay,
      //         "Width": productDetails?.model?.dimensions?.find(d => d.description === "Width")?.dimensiondisplay,
      //         "picpath": productDetails?.model?.pictures[0]?.picpath,
      //         "height": productDetails?.model?.pictures[0]?.height,
      //         "width": productDetails?.model?.pictures[0]?.width,
      //         "notesUrl": productDetails?.model?.notes[0]
      //       };
      //       return await updateModalContent(part, proDetails);
      //     })
      //     .catch(error => console.error('Error fetching product details:', error));
      // }
      function openImageModal(imageUrl) {
        let modal = document.getElementById("modal-quick-view");
        modal.classList.add('is-loading');
        modal.setAttribute('aria-hidden', 'true');
        document.querySelector('body').classList.remove('show_overlay');

        // Fetch image details and update modal content
        fetchImageDetailsAndOpenModal(imageUrl)
          .then(content => {
            modal.querySelector('.modal__inner').innerHTML = content;
            modal.classList.remove('is-loading');
            document.querySelector('body').classList.add('show_overlay');
            modal.setAttribute('aria-hidden', 'false');
          });
      }

      // Function to handle modal content update for images
      async function fetchImageDetailsAndOpenModal(imageUrl) {
        // Fetch image details if necessary (currently not implemented in the code)
        // Placeholder for fetching image details
        const imageDetails = {
          imageUrl: imageUrl // Assuming you might need some image details in the future
        };

        // Return the HTML content for the image modal
        return updateImageModalContent(imageDetails);
      }

      async function fetchProductDetailsAndOpenModal(product) {
        console.log("product", product);
        return await fetchProductDetails(product.partid)
          .then(async productDetails => {
            document.cookie = `xuserid=${productDetails?.xuserid}; path=/`;
            const proDetails = {
              "ID": productDetails?.model?.dimensions?.find(d => d.description === "ID")?.dimensiondisplay,
              "OD": productDetails?.model?.dimensions?.find(d => d.description === "OD")?.dimensiondisplay,
              "Width": productDetails?.model?.dimensions?.find(d => d.description === "Width")?.dimensiondisplay,
              "pictures": productDetails?.model?.pictures,
              "height": productDetails?.model?.pictures[0]?.height,
              "width": productDetails?.model?.pictures[0]?.width,
              "notes": productDetails?.model?.notes,
              "partFitments":productDetails?.partFitments
            };
            return await updateModalContent(product, proDetails);
          })
          .catch(error => console.error('Error fetching product details:', error));
      }

      // Function to update modal content with product details
async function  updateModalContent(productInfo, Details) {
  var notesHtml=""
   //const modalContent = document.getElementById('modal-quick-view');
   if (Details.notes && Details.notes.length > 0) {
    //  console.log("product_info", Details.notes);
     notesHtml = Details.notes.map(note => 
         `<a class="btn btn-outline-primary my-1" href='https://api.autoinfo.com.au${note.notepath}' target="_blank" download>${note.notedescription}</a> </br>`
     ).join('');
 }
 
 let imagesHtml = '';
 if (Details.pictures && Details.pictures.length > 0) {
   imagesHtml = `<div class="col-md-6">` + Details.pictures.map(picture => 
       `<img src="https://api.autoinfo.com.au${picture.picpath}" class="img-fluid" alt="Image">`
   ).join('') + `</div>`;
 }
   // Update modal content based on productDetails
   let fitmentImages='';
       if (Details.partFitments?.vehiclesImages && Details.partFitments?.vehiclesImages?.length > 0) {
       fitmentImages=`<div class="col-md-6">`+ Details.partFitments.vehiclesImages.map(image => {
        if (image && image.vehiclesImageUrl) {
            return `
                
                    <img src="https://api.autoinfo.com.au${image.vehiclesImageUrl}" alt="Vehicle Image" class="img-fluid">
                
            `;
        }
        return '';
    }).join('')+`</div>`;
              }
     return  `
     <div class="bg-white">
     
     <div class="modal-header">
         <h2 class="modal-title" id="productModalLabel">${productInfo.partno}</h2></div>
     <div class="modal-body">
     <div class="row">
   
     ${imagesHtml}
 
     <div class="col-md-6 modal-text">
     <p><span class="text-primary"><strong>Product Name:</strong></span> ${productInfo.partno }</p>
     <p><span class="text-primary"><strong>Description:</strong></span><br/> ${productInfo.partDescription}</p>
     ${productInfo.footnote === productInfo.longFootnote ? 
       (productInfo.footnote ? 
         `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.footnote}</p>` : 
         '') :
       (productInfo.footnote ? 
         `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.footnote}</p>` : 
         '') +
       (productInfo.longFootnote ? 
         `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.longFootnote}</p>` : 
         '') 
     }  
 
     ${Details.footnote ? 
       `<p><span class="text-primary"><strong> Id:</strong></span> ${Details.ID}</p>`:''}
     ${Details.OD ? 
       `<p><span class="text-primary"><strong>OD:</strong></span> ${Details.OD}</p>`:''}
     ${Details.Width ? 
       `<p><span class="text-primary"><strong>Width:</strong></span> ${Details.Width}</p>`:''}
       <div>
       ${notesHtml}
      </div>
     </div>
     ${fitmentImages}
     </div>
     </div>
     </div>
     `; 
 }
 
      // Function to update image modal content
      function updateImageModalContent(imageDetails) {
        // Construct HTML content for the image modal
        // If imageUrl is a placeholder, don't prepend the API URL
        const isPlaceholder = imageDetails.imageUrl === placeholderImageUrl;
        const imgSrc = isPlaceholder
          ? imageDetails.imageUrl
          : `https://api.autoinfo.com.au${imageDetails.imageUrl}`;
        return `
    <div class="bg-white">
      <img src="${imgSrc}" class="img-fluid mx-auto d-block" alt="Image">
    </div>
  `;
      }
      // Function to fetch product details from backend API
function fetchProductDetails(productId) {
  // Replace this with actual fetch call to your backend API
   return new Promise((resolve, reject) => {
    // Example URL
    const apiUrl = `https://${baseEndPoint}/AutoInfoSearchNZ/GetPartDetails?partId=${productId}`;
    fetch(apiUrl, {
      headers: {
        'xuserid': getCookieValue('xuserid')
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
       
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

    }
    // Check if there are results to render
    else {
      // If no parts are found, display a message
      var noPartsMessage = document.createElement('div');
      noPartsMessage.textContent = `No matching part found for ${partNo}`;
      noPartsMessage.style.fontWeight = 'bold';
      noPartsMessage.style.color = 'red';
      resultsContainer.appendChild(noPartsMessage);
  }
  }

});